import { createFileRoute } from "@tanstack/react-router";
import "@fontsource/fragment-mono/latin-400.css";
import "@fontsource/special-gothic-expanded-one/latin-400.css";
import { Brief } from "@/components/soad/Brief";
import { Page, PageHead } from "@/components/soad/Pages";
import "@/styles/soad.css";

export const Route = createFileRoute("/contact")({ component: ContactPage });

function ContactPage() {
  return (
    <Page>
      <PageHead label="contact" lines={["Have a project", "for us?"]}>
        <p className="sd-page-lede">tell us what you want to make. we will tell you how we would build it.</p>
      </PageHead>
      <Brief />
    </Page>
  );
}
